function ResearchCompleteIcon(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 50 50"
      fill="#AEAAB5"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path fill="#fff" d="M0 0h50v50H0z" />
      <path d="M24.56 15.83a1.417 1.417 0 00-1.008-.416h-.002a1.417 1.417 0 00-1.01.419l-1.08 1.085a.662.662 0 00-.05.046l-1.8 1.808a.815.815 0 00-.07.061l-1.768 1.776-1.766-1.765a1.45 1.45 0 00-2.044 0l-.017.016a1.429 1.429 0 00.003 2.02l2.837 2.826.386.386a.85.85 0 001.206 0l6.202-6.203a1.446 1.446 0 00-.003-2.043l-.015-.015z" />
      <path d="M46.99 41.184l-9.087-8.7a3.723 3.723 0 00-3.066-1l-1.857-2.13a16.533 16.533 0 00-2.205-21.627 16.93 16.93 0 00-23.722.582 16.93 16.93 0 00.692 23.702 16.532 16.532 0 0021.712 1.058l2.226 1.741a3.73 3.73 0 001.161 3.01l9.17 8.614c.275.259.638.403 1.015.404.247 0 .49-.063.704-.184a8.762 8.762 0 002.043-1.595l.074-.076a8.808 8.808 0 001.452-2.093 1.464 1.464 0 00-.313-1.706zM31.528 21.312a12.15 12.15 0 01-3.357 7.015 12.213 12.213 0 01-15.967 1.69 12.356 12.356 0 1116.815-17.73 12.142 12.142 0 012.509 9.025z" />
    </svg>
  )
}

export default ResearchCompleteIcon
